//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import { axiosGet } from '../../../../axios/axios.js'

export default {
  name: 'UserPassword',
  props: {
    value: String,
    editable: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: 'ВВЕДИТЕ ПАРОЛЬ'
    },
    rules: {
      type: Array,
      default: null
    },
    newPassword: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      showingPassword: false,
      error: false,
      errorMsg: ''
    }
  },
  methods: {
    // available from outside
    validate: function () {
      this.$refs.field.validate()
      // console.log(this.$refs.field.hasError)
      return !this.$refs.field.hasError
    },
    onInput: function (val) {
      if (this.error) {
        this.error = false
        this.errorMsg = ''
      }
      this.$emit('input', val)
    },
    onShowPassword: function () {
      const inputCmp = this.$refs.field
      const inputEl = inputCmp.$el.querySelector('input')
      this.showingPassword = !this.showingPassword
      if (inputEl.type === 'password') {
        inputEl.type = 'text'
      } else {
        inputEl.type = 'password'
      }
    },
    onClear: function () {
      this.$emit('input', '')
    },
    // available from outside
    // no validation error
    reset: function () {
      this.$emit('input', '')
      Vue.nextTick(() => this.$refs.field.resetValidation())
    },
    // available from outside
    setInvalid (message = '') {
      this.error = true
      this.errorMsg = message
    },
    onGenPassword: function () {
      axiosGet({
        url: '/service/user/genpassword',
        onSuccess: (response) => {
          this.$emit('input', response.data.result)
        }
      })
    }
  }
}

